import { render, staticRenderFns } from "./FormDataEntriesModal.vue?vue&type=template&id=2835b306"
import script from "./FormDataEntriesModal.vue?vue&type=script&lang=js"
export * from "./FormDataEntriesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports